// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__mlPsv","title":"styles_title__fUNqO","details":"styles_details__pWzkZ","bodyStyles":"styles_bodyStyles__bkzv0","button":"styles_button__VoILN"};